import { IdValue } from '~/api/IdValue';

export const departments: IdValue[] = [
  { id: '1', value: 'Behavioral-Mental Health Unit' },
  { id: '2', value: 'Burn Unit' },
  { id: '3', value: 'Cardiac Cath Lab' },
  { id: '4', value: 'CCU - Cardiac Care Unit' },
  { id: '5', value: 'OB - Obstetrics' },
  { id: '6', value: 'Emergency Department' },
  { id: '7', value: 'Hospice' },
  { id: '8', value: 'ICU - Intensive Care Unit' },
  { id: '9', value: 'Med / Surg Unit' },
  { id: '10', value: 'Neonatal ICU' },
  { id: '11', value: 'Neuro Unit' },
  { id: '12', value: 'Outpatient Surgery' },
  { id: '13', value: 'PACU' },
  { id: '14', value: 'Radiology' },
  { id: '15', value: 'Skilled Nursing Unit' },
  { id: '16', value: 'Trauma Unit' },
];

export const getDepartmentById = (id?: string): IdValue | undefined => departments.find((d) => d.id === id);

export const getDepartmentNamesByIds = (ids: string[]): string[] => ids
  .map((id) => getDepartmentById(id)?.value)
  .filter(Boolean) as string[];
